import { ToggleSwitch as ZuiToggleSwitch } from 'components/Zui'
import { Field, ErrorMessage } from 'formik'
import FieldError from './FieldError'

export const ToggleSwitch = props => {
    return (
        <div className="toggle-wrapper-row">
            <div className="toggle-label-row">
                <span>{props.label}</span>
            </div>
            <div className="toggle-field-wrapper">
                <Field component={ToggleComponent} {...props} />
                <ErrorMessage name={props.name} component={FieldError} />
            </div>
        </div>
    )
}

const ToggleComponent = ({ field, ...props }) => {
    return <ZuiToggleSwitch {...field} {...props}></ZuiToggleSwitch>
}
